(function () {
  if (window.__pdpRecipePickerLoaded) return;
  window.__pdpRecipePickerLoaded = true;

  function init(root) {
    if (!root || root.dataset.prpInitialized === 'true') return;
    root.dataset.prpInitialized = 'true';

    const configEl = root.querySelector('[data-prp-config]');
    const mount = root.querySelector('[data-prp-mount]');
    if (!configEl || !mount) return;

    const cfg = JSON.parse(configEl.textContent || '{}');
    const { productFormId, options, variants, sets } = cfg;
    const strings = cfg.strings || {};
    const str = (key, fallback = '') => strings[key] || fallback;
    const formatStr = (key, replacements, fallback = '') => {
      let value = str(key, fallback);
      Object.entries(replacements || {}).forEach(([name, replacement]) => {
        value = value.replaceAll(`{{ ${name} }}`, replacement);
      });
      return value;
    };

    // All steps are preselected on load. Set-steps are collapsed by default and can be edited by click.
    let activeSetIndex = null;
    let configuratorOpen = false;

    const selectedOptions = options.map(() => null);
    const setSelections = {};

    const requestedVariant = variants.find(v => v.id === cfg.initialVariantId);
    const digitalVariant = variants.find(v => v.option1 === 'Digital' || v.option2 === 'Digital' || v.option3 === 'Digital');
    const initV = requestedVariant || digitalVariant || variants[0];

    if (initV) {
      if (initV.option1 != null) selectedOptions[0] = initV.option1;
      if (initV.option2 != null) selectedOptions[1] = initV.option2;
      if (initV.option3 != null) selectedOptions[2] = initV.option3;
    }

    const SWATCH_LIMIT = 9999;
    let upsellController = null;
    let lastUpsellVariantId = null;

    const esc = (s) =>
      String(s || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');

    const isDigitalInstructionItem = (item) =>
      String(item?.product_variation_names || '').trim().toLowerCase() === 'digital';

    const moneyFormat = cfg.moneyFormat || window.gwaMoneyFormat || '';

    const formatMoney = (cents) => {
      const value = Number(cents || 0);
      if (value === 0) return str('free', 'Gratis');
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(value, moneyFormat);
      }
      return (value / 100).toFixed(2).replace('.', ',') + '\u00A0€';
    };

    const findVariant = (opts) =>
      variants.find(v => {
        const o = [v.option1, v.option2, v.option3];
        return opts.every((val, i) => val == null || o[i] === val);
      });

    const getSetItems = () => {
      const v = findVariant(selectedOptions) || initV;
      const raw = v ? (sets[String(v.id)] || []) : [];
      return [...raw].sort((a, b) => (parseInt(a.position, 10) || 0) - (parseInt(b.position, 10) || 0));
    };

    const buildSteps = () => {
      const steps = options.map((name, i) => ({
        type: 'option',
        optionIndex: i,
        optionName: name
      }));

      getSetItems().forEach((item, i) => {
        if (isDigitalInstructionItem(item)) return;

        steps.push({
          type: 'set',
          setIndex: i,
          item
        });
      });

      return steps;
    };

    const getProductForm = () =>
      productFormId
        ? document.getElementById(productFormId)
        : document.querySelector('form[action*="/cart/add"]');

    const getProductInfoRoot = () =>
      document.getElementById('ProductInfo-' + cfg.sectionId) ||
      root.closest('product-info') ||
      document.querySelector('product-info') ||
      document;

    const refreshUpsellForVariant = async (variantId) => {
      if (!variantId || !cfg.productUrl || !cfg.sectionId) return;

      const nextVariantId = String(variantId);
      if (nextVariantId === lastUpsellVariantId) return;
      lastUpsellVariantId = nextVariantId;

      if (upsellController) upsellController.abort();
      upsellController = new AbortController();

      const requestUrl =
        `${cfg.productUrl}?variant=${encodeURIComponent(nextVariantId)}` +
        `&section_id=${encodeURIComponent(String(cfg.sectionId))}`;

      try {
        const res = await fetch(requestUrl, {
          signal: upsellController.signal,
          credentials: 'same-origin'
        });
        const text = await res.text();
        if (upsellController.signal.aborted) return;

        const html = new DOMParser().parseFromString(text, 'text/html');
        const productInfo = getProductInfoRoot();
        const currentUpsell = productInfo.querySelector('[data-upsell]');
        const nextUpsell = html.querySelector('[data-upsell]');

        if (currentUpsell && nextUpsell) {
          currentUpsell.replaceWith(nextUpsell);
          document.dispatchEvent(new CustomEvent('pdp:upsell:updated', { detail: { root: nextUpsell } }));
        } else if (currentUpsell && !nextUpsell) {
          currentUpsell.remove();
        } else if (!currentUpsell && nextUpsell) {
          const anchor = productInfo.querySelector('product-form') ||
            productInfo.querySelector('[data-pvs]') ||
            root;
          if (anchor) {
            anchor.insertAdjacentElement('afterend', nextUpsell);
            document.dispatchEvent(new CustomEvent('pdp:upsell:updated', { detail: { root: nextUpsell } }));
          }
        }
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.warn('[PRP] Failed to refresh upsell', error);
        }
      }
    };

    const getPriceWrapper = () => {
      const selectors = [
        '#price-template--' + cfg.sectionId + '__main',
        '#price-' + cfg.sectionId,
        '[id^="price-template--"][id$="__main"]',
        '.product__info-container [id^="price-template--"]',
        '.product__info-container .price'
      ];
      for (const selector of selectors) {
        const el = document.querySelector(selector);
        if (el) return el;
      }
      return null;
    };

    const getCurrentRecipeVariant = () => findVariant(selectedOptions) || initV || null;

    const cloneSelection = (obj) => ({
      variantId: obj?.variantId ?? null,
      quantity: Number(obj?.quantity ?? 0),
      customized: obj?.customized === true
    });

    const pickDefaultVariant = (item) => {
      // Always use the configured default variant (recipe color).
      // Sold-out status is handled at submit time with a user-visible error.
      return item.variants.find(v => v.id === item.default_variant_id)
        || item.variants[0]
        || null;
    };

    const getSetItemsForVariant = (variant) => {
      if (!variant) return [];
      const raw = sets[String(variant.id)] || [];
      return [...raw].sort((a, b) => (parseInt(a.position, 10) || 0) - (parseInt(b.position, 10) || 0));
    };

    // A virtual set may contain the same product several times (Paulina uses six
    // Piuma slots) and legacy data may give every item the same position. Keep
    // each configured slot distinct while carrying its colour to another size.
    // The ordered slot index is stable across the size-specific set definitions;
    // variation names are deliberately excluded because they contain the size.
    const getSetItemSelectionKey = (item, index) => [
      item?.product_id || item?.product_handle || item?.product_title || '',
      index
    ].join('|');

    const isColorOption = (name) => {
      const normalized = String(name || '').trim().toLowerCase();
      return ['farbe', 'color', 'colour', 'garn'].some(part => normalized.includes(part));
    };

    const getCurrentSelectionsBySetItem = (targetVariant) => {
      const selectionsByItem = new Map();
      if (targetVariant && options.some((name, index) =>
        isColorOption(name) && targetVariant[`option${index + 1}`] !== selectedOptions[index]
      )) return selectionsByItem;

      getSetItems().forEach((item, index) => {
        const selection = getDisplaySelection(index, item);
        if (targetVariant && targetVariant.id !== getCurrentRecipeVariant()?.id && !selection.customized) return;
        selectionsByItem.set(
          getSetItemSelectionKey(item, index),
          cloneSelection(selection)
        );
      });
      return selectionsByItem;
    };

    const getConfiguredSetAvailabilityIssueForVariant = (variant) => {
      if (!variant) return null;

      if (variant.variation_set_missing === true) {
        return {
          type: 'missing-set',
          variant,
          message: str('setUnavailable', 'Dieses Set ist aktuell nicht verfügbar.')
        };
      }

      if (variant.available === false) {
        return {
          type: 'recipe',
          variant,
          message: formatStr('setSoldOut', { title: cfg.productTitle || 'Set' }, `"${cfg.productTitle || 'Set'}" ist ausverkauft.`)
        };
      }

      const items = getSetItemsForVariant(variant);
      const selectionsByItem = getCurrentSelectionsBySetItem(variant);
      for (let i = 0; i < items.length; i += 1) {
        const item = items[i];
        if (isDigitalInstructionItem(item)) continue;

        const configuredSelection = selectionsByItem.get(getSetItemSelectionKey(item, i));
        const selectedVariant = configuredSelection?.variantId
          ? item.variants.find(v => v.id === configuredSelection.variantId)
          : null;
        const componentVariant = selectedVariant || pickDefaultVariant(item);

        if (!item.default_variant_id || !componentVariant || Number(item.quantity || 0) <= 0) {
          return {
            type: 'missing-set',
            item,
            message: str('setUnavailable', 'Dieses Set ist aktuell nicht verfügbar.')
          };
        }

        if (componentVariant.available === false) {
          const colorName = componentVariant.title || '';
          return {
            type: 'component',
            item,
            variant: componentVariant,
            message: formatStr(
              'soldOutChooseColor',
              { title: `${item.product_title}${colorName ? ' – ' + colorName : ''}` },
              `"${item.product_title}${colorName ? ' – ' + colorName : ''}" is sold out. Please choose another color.`
            )
          };
        }
      }

      return null;
    };

    const ensureSelectionsForItems = (items) => {
      items.forEach((item, i) => {
        if (!setSelections[i]) {
          const defV = pickDefaultVariant(item);
          setSelections[i] = {
            variantId: defV ? defV.id : (item.default_variant_id || null),
            quantity: Number(parseInt(item.quantity, 10) || 0),
            customized: false
          };
        }
      });
    };

    const getDisplaySelection = (index, item) => {
      const live = setSelections[index];
      if (live) return live;
      const defV = pickDefaultVariant(item);
      return {
        variantId: defV ? defV.id : (item.default_variant_id || null),
        quantity: Number(parseInt(item.quantity, 10) || 0),
        customized: false
      };
    };

    const parseQty = (value) => {
      const n = Number(parseInt(value, 10));
      return Number.isFinite(n) && n > 0 ? n : 1;
    };

    const getMainQuantity = () => {
      const form = getProductForm();
      const candidates = [
        form?.querySelector('input[name="quantity"]'),
        form?.querySelector('quantity-input input'),
        form?.querySelector('.quantity__input'),
        document.querySelector(`#${CSS.escape(productFormId || '')} input[name="quantity"]`),
        document.querySelector('#MainProduct-' + cfg.sectionId + ' input[name="quantity"]'),
        document.querySelector('#MainProduct-' + cfg.sectionId + ' quantity-input input'),
        document.querySelector('#MainProduct-' + cfg.sectionId + ' .quantity__input'),
        document.querySelector('.product-form__quantity input[name="quantity"]'),
        document.querySelector('.product-form__quantity .quantity__input'),
        document.querySelector('form[action*="/cart/add"] input[name="quantity"]'),
        document.querySelector('form[action*="/cart/add"] quantity-input input'),
        document.querySelector('form[action*="/cart/add"] .quantity__input')
      ].filter(Boolean);

      for (const input of candidates) {
        const qty = parseQty(input.value);
        if (qty > 0) return qty;
      }
      return 1;
    };

    // Carry compatible color selections to the newly selected size while using
    // the new size's quantities. Unmatched components fall back to their defaults.
    const resetSetSteps = (previousItems = []) => {
      const previousSelectionsByItem = new Map();
      previousItems.forEach((item, index) => {
        const selection = getDisplaySelection(index, item);
        if (!selection.customized) return;
        previousSelectionsByItem.set(
          getSetItemSelectionKey(item, index),
          cloneSelection(selection)
        );
      });

      Object.keys(setSelections).forEach(k => delete setSelections[k]);
      activeSetIndex = null;
      configuratorOpen = false;

      getSetItems().forEach((item, index) => {
        const previousSelection = previousSelectionsByItem.get(getSetItemSelectionKey(item, index));
        const compatibleVariant = previousSelection?.variantId
          ? item.variants.find(v => v.id === previousSelection.variantId)
          : null;
        const fallbackVariant = pickDefaultVariant(item);

        setSelections[index] = {
          variantId: compatibleVariant?.id || fallbackVariant?.id || item.default_variant_id || null,
          quantity: Number(parseInt(item.quantity, 10) || 0),
          customized: !!compatibleVariant && previousSelection.customized === true
        };
      });
    };

    const getLiveVisualTotalPrice = () => {
      const recipeV = getCurrentRecipeVariant();
      const items = getSetItems();
      const mainQty = getMainQuantity();
      const recipePrice = Number(recipeV?.price || 0);
      let componentsTotal = 0;

      items.forEach((item, i) => {
        if (isDigitalInstructionItem(item)) return;

        const sel = getDisplaySelection(i, item);
        if (!sel) return;

        const qty = Number(sel.quantity || 0);
        if (qty <= 0) return;

        const selectedVariant =
          item.variants.find(v => v.id === sel.variantId) ||
          item.variants.find(v => v.id === item.default_variant_id) ||
          item.variants[0];

        componentsTotal += Number(selectedVariant?.price || 0) * qty * mainQty;
      });

      if (cfg.hasDigital) return recipePrice + componentsTotal;

      // The ERP can create the set components before assigning the bundle
      // variant price. Do not expose a temporary zero-price bundle as Gratis.
      return recipePrice > 0 ? recipePrice : componentsTotal;
    };

    const getLiveVisualCompareAtPrice = () => {
      const recipeV = getCurrentRecipeVariant();
      const items = getSetItems();
      const mainQty = getMainQuantity();
      const recipeCompareAtPrice = Number(
        recipeV?.compare_at_price && recipeV.compare_at_price > recipeV.price
          ? recipeV.compare_at_price
          : recipeV?.price || 0
      );
      let componentsTotal = 0;

      items.forEach((item, i) => {
        if (isDigitalInstructionItem(item)) return;

        const sel = getDisplaySelection(i, item);
        if (!sel) return;

        const qty = Number(sel.quantity || 0);
        if (qty <= 0) return;

        const selectedVariant =
          item.variants.find(v => v.id === sel.variantId) ||
          item.variants.find(v => v.id === item.default_variant_id) ||
          item.variants[0];

        componentsTotal += Number(selectedVariant?.price || 0) * qty * mainQty;
      });

      if (cfg.hasDigital) return recipeCompareAtPrice + componentsTotal;
      return recipeCompareAtPrice > 0 ? recipeCompareAtPrice : componentsTotal;
    };

    const formatKg = (grams) => {
      const kg = Number(grams || 0) / 1000;
      if (!Number.isFinite(kg) || kg <= 0) return '';

      return kg
        .toFixed(2)
        .replace(/\.00$/, '')
        .replace(/(\.\d)0$/, '$1')
        .replace('.', ',');
    };

    const getLiveVisualTotalWeightGrams = () => {
      const recipeV = getCurrentRecipeVariant();
      const items = getSetItems();
      const mainQty = getMainQuantity();

      if (!items.length) return Number(recipeV?.weight || 0);

      let total = 0;

      items.forEach((item, i) => {
        if (isDigitalInstructionItem(item)) return;

        const sel = getDisplaySelection(i, item);
        if (!sel) return;

        const qty = Number(sel.quantity || 0);
        if (qty <= 0) return;

        const selectedVariant =
          item.variants.find(v => v.id === sel.variantId) ||
          item.variants.find(v => v.id === item.default_variant_id) ||
          item.variants[0];

        total += Number(selectedVariant?.weight || 0) * qty * mainQty;
      });

      return total;
    };

    const updateUnitPriceDisplay = (priceRoot, saleTotal) => {
      const unitLine = priceRoot.querySelector('.ppl-price__unit');
      if (!unitLine) return;

      const totalWeightGrams = getLiveVisualTotalWeightGrams();
      if (!totalWeightGrams) {
        unitLine.innerHTML = '';
        unitLine.hidden = true;
        return;
      }

      const contentKg = formatKg(totalWeightGrams);
      const perKg = Math.round(Number(saleTotal || 0) * 1000 / totalWeightGrams);
      unitLine.innerHTML = `${esc(str('productContent', 'Content'))}: ${contentKg} kg (${formatMoney(perKg)} / 1 kg)`;
      unitLine.hidden = false;
    };

    const updatePriceDisplay = () => {
      const wrapper = getPriceWrapper();
      if (!wrapper) return;

      const priceRoot = wrapper.classList?.contains('price')
        ? wrapper
        : wrapper.querySelector('.price') || wrapper;

      if (!priceRoot) return;

      const recipeV = getCurrentRecipeVariant();
      const saleTotal = getLiveVisualTotalPrice();
      const compareAtTotal = getLiveVisualCompareAtPrice();
      const formatted = formatMoney(saleTotal);

      const isOnSale = compareAtTotal > saleTotal;

      priceRoot.classList.remove('price--sold-out');

      if (isOnSale) {
        const formattedCompare = formatMoney(compareAtTotal);
        const discPct = compareAtTotal > saleTotal
          ? Math.round((compareAtTotal - saleTotal) / compareAtTotal * 100)
          : 0;

        priceRoot.classList.add('price--on-sale');

        priceRoot.querySelectorAll('.price__sale .price-item--sale').forEach((el) => {
          el.innerHTML = formatted;
        });

        priceRoot.querySelectorAll('.price__sale .price-item--regular').forEach((el) => {
          el.innerHTML = formattedCompare;
        });

        priceRoot.querySelectorAll('.price__badge-sale').forEach((badge) => {
          badge.style.display = '';
          if (discPct > 0) badge.textContent = `-${discPct}%`;
        });
      } else {
        priceRoot.classList.remove('price--on-sale');

        priceRoot.querySelectorAll('.price__regular .price-item--regular').forEach((el) => {
          el.innerHTML = formatted;
        });

        priceRoot.querySelectorAll('.price__sale .price-item--sale').forEach((el) => {
          el.innerHTML = formatted;
        });

        priceRoot.querySelectorAll('.price__sale .price-item--regular').forEach((el) => {
          el.innerHTML = '';
        });

	        priceRoot.querySelectorAll('.price__badge-sale').forEach((badge) => {
	          badge.style.display = 'none';
	        });
	      }

	      updateUnitPriceDisplay(priceRoot, saleTotal);
	    };

    const schedulePriceDisplayUpdate = () => {
      updatePriceDisplay();
      window.setTimeout(updatePriceDisplay, 0);
      window.setTimeout(updatePriceDisplay, 150);
      window.setTimeout(updatePriceDisplay, 500);
    };

    const syncFormVariant = () => {
      const v = getCurrentRecipeVariant();
      if (!v) return;
      const form = getProductForm();
      const input = form?.querySelector('input[name="id"]');
      if (input) {
        input.value = v.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    };

    const getSetAvailabilityIssue = (items) => {
      const currentItems = items || getSetItemsForCurrentVariant();
      const recipeV = getCurrentRecipeVariant();

      if (recipeV && recipeV.available === false) {
        return {
          type: 'recipe',
          variant: recipeV,
          message: formatStr('setSoldOut', { title: cfg.productTitle || 'Set' }, `"${cfg.productTitle || 'Set'}" ist ausverkauft.`)
        };
      }

      if (recipeV && recipeV.variation_set_missing === true) {
        return {
          type: 'missing-set',
          variant: recipeV,
          message: str('setUnavailable', 'Dieses Set ist aktuell nicht verfügbar.')
        };
      }

      if (!currentItems.length) {
        if (cfg.hasDigital) {
          return {
            type: 'missing-set',
            message: str('setUnavailable', 'Dieses Set ist aktuell nicht verfügbar.')
          };
        }
        return null;
      }
      ensureSelectionsForItems(currentItems);

      for (let i = 0; i < currentItems.length; i += 1) {
        const item = currentItems[i];
        if (isDigitalInstructionItem(item)) continue;

        const live = getDisplaySelection(i, item);
        if (!live?.variantId || Number(live.quantity || 0) <= 0) {
          return {
            type: 'missing-set',
            item,
            message: str('setUnavailable', 'Dieses Set ist aktuell nicht verfügbar.')
          };
        }

        const selV = item.variants.find(v => v.id === live.variantId);
        if (!selV) {
          return {
            type: 'missing-set',
            item,
            message: str('setUnavailable', 'Dieses Set ist aktuell nicht verfügbar.')
          };
        }
        if (selV && selV.available === false) {
          const colorName = selV.title || '';
          return {
            type: 'component',
            item,
            variant: selV,
            message: formatStr(
              'soldOutChooseColor',
              { title: `${item.product_title}${colorName ? ' – ' + colorName : ''}` },
              `"${item.product_title}${colorName ? ' – ' + colorName : ''}" is sold out. Please choose another color.`
            )
          };
        }
      }

      return null;
    };

    const setSubmitButtonState = (issue) => {
      const form = getProductForm();
      const submitBtn = form?.querySelector('[type="submit"]');
      if (!submitBtn) return;

      const label = submitBtn.querySelector('span') || submitBtn;
      if (!submitBtn.dataset.prpAvailableLabel) {
        submitBtn.dataset.prpAvailableLabel =
          submitBtn.getAttribute('data-label-add') ||
          label.textContent.trim() ||
          str('addToCart', 'Add to cart');
      }

      if (issue) {
        submitBtn.disabled = true;
        submitBtn.setAttribute('aria-disabled', 'true');
        submitBtn.dataset.prpSetSoldOut = 'true';
        submitBtn.title = issue.message || '';
        label.textContent = issue.type === 'missing-set'
          ? (submitBtn.getAttribute('data-label-unavailable') || str('unavailable', 'Unavailable'))
          : (submitBtn.getAttribute('data-label-soldout') || str('soldOut', 'Sold out'));
        return;
      }

      if (submitBtn.dataset.prpSetSoldOut === 'true') {
        submitBtn.disabled = false;
        submitBtn.removeAttribute('aria-disabled');
        submitBtn.removeAttribute('title');
        delete submitBtn.dataset.prpSetSoldOut;
        label.textContent = submitBtn.dataset.prpAvailableLabel;
      }
    };

    const setAvailabilityInfoState = (issue) => {
      const productRoot = document.getElementById('MainProduct-' + cfg.sectionId) || document;
      productRoot.querySelector('[data-quantity-shipping]')?.classList.toggle('hidden', Boolean(issue));
      const inventoryInfo = productRoot.querySelector('.product__inventory');
      inventoryInfo?.classList.toggle('hidden', Boolean(issue) || !inventoryInfo.textContent.trim());
      const infoItem = productRoot.querySelector('.ppl-qtyInfo__item_first');
      if (!infoItem) return;

      const dot = infoItem.querySelector('.ppl-qtyInfo__dot');
      const text = infoItem.querySelector('.ppl-qtyInfo__text');
      if (!text) return;

      if (!text.dataset.prpDefaultText) {
        text.dataset.prpDefaultText = text.textContent.trim();
      }

      if (issue) {
        infoItem.classList.add('ppl-qtyInfo__item--sold-out');
        dot?.classList.add('ppl-qtyInfo__dot--sold-out');
        text.textContent = cfg.restockEnabled === false
          ? str('soldOut', 'Sold out')
          : text.dataset.labelSoldoutSoon || str('soldOutSoon', 'Sold out. Available again soon');
        infoItem.title = issue.message || '';
        return;
      }

      infoItem.classList.remove('ppl-qtyInfo__item--sold-out');
      dot?.classList.remove('ppl-qtyInfo__dot--sold-out');
      text.textContent = text.dataset.prpDefaultText || text.textContent;
      infoItem.removeAttribute('title');
    };

    const getAppikonInlineForm = () =>
      document.getElementById('appikon-bis-inline-form-wrapper');

    const createBackInStockFallbackForm = () => {
      if (cfg.restockEnabled === false) return null;
      const existing = getAppikonInlineForm();
      if (existing) return existing;

      const anchor =
        getProductForm()?.closest('.product-form__wrapper') ||
        getProductForm() ||
        root;
      if (!anchor) return null;

      const form = document.createElement('div');
      form.id = 'appikon-bis-inline-form-wrapper';
      form.className = 'appikon-bis-inline-form-wrapper';
      form.style.display = 'none';
      form.innerHTML = `
        <div class="clearfix">
          <div class="appikon-bis-inline-form-title">
            <h3>${esc(str('backInStockTitle', 'Back-in-stock notification'))}</h3>
          </div>
          <div class="appikon-bis-inline-form-description">
            ${esc(str('backInStockDescription', 'We will notify you as soon as this product is available again.'))}
          </div>
          <div class="appikon-bis-inline-form-data">
            <form id="appikon-bis-inline-form">
              <div id="customer-contact-container">
                <div id="email-address">
                  <div class="appikon-bis-inline-input-section">
                    <input
                      id="appikon-bis-inline-form-email"
                      class="appikon-bis-inline-form-input input-lg"
                      type="email"
                      name="appikon-bis-inline-form-email"
                      placeholder="${esc(str('emailPlaceholder', 'E-Mail-Adresse'))}"
                    >
                  </div>
                </div>
                <button id="appikon-bis-inline-form-submit" class="btn button appikon-bis-inline-form-submit" type="submit">
                  ${esc(str('notifyMe', 'Benachrichtige mich'))}
                </button>
              </div>
            </form>
            <div id="appikon-bis-inline-form-message"></div>
          </div>
          <div class="appikon-bis-inline-form-footer">
            <div id="appikon-bis-inline-form-footer-note">
              ${esc(str('privacyEmail', 'We respect your privacy and do not share your email address with third parties.'))}
            </div>
          </div>
        </div>
      `;

      anchor.insertAdjacentElement('afterend', form);
      return form;
    };

    const setBackInStockFormState = (issue, attempt = 0) => {
      if (cfg.restockEnabled === false) {
        const disabledForm = getAppikonInlineForm();
        if (disabledForm) {
          disabledForm.dataset.prpBisActive = 'false';
          disabledForm.hidden = true;
          disabledForm.style.display = 'none';
        }
        return;
      }
      const form = getAppikonInlineForm() || (issue ? createBackInStockFallbackForm() : null);

      if (!form) {
        if (issue && attempt < 8) {
          window.setTimeout(() => setBackInStockFormState(issue, attempt + 1), 250);
        }
        return;
      }

      const variantId = issue?.variant?.id;
      const productId = issue?.variant?.product_id || issue?.item?.product_id;

      if (issue && variantId && productId) {
        form.dataset.prpBisActive = 'true';
        form.dataset.prpBisVariantId = String(variantId);
        form.dataset.prpBisProductId = String(productId);
        form.dataset.prpBisProductTitle = issue.item?.product_title || '';
        form.dataset.prpBisProductVendor = issue.item?.product_vendor || '';
        form.dataset.prpBisProductHandle = issue.item?.product_handle || '';
        form.dataset.prpBisVariantTitle = issue.variant?.title || '';
        form.dataset.prpBisVariantSku = issue.variant?.sku || '';
        form.style.display = '';
        form.hidden = false;
        return;
      }

      if (form.dataset.prpBisActive === 'true') {
        form.dataset.prpBisActive = 'false';
        delete form.dataset.prpBisVariantId;
        delete form.dataset.prpBisProductId;
        delete form.dataset.prpBisProductTitle;
        delete form.dataset.prpBisProductVendor;
        delete form.dataset.prpBisProductHandle;
        delete form.dataset.prpBisVariantTitle;
        delete form.dataset.prpBisVariantSku;
        form.style.display = 'none';
      }
    };

    const updateSetAvailabilityDisplay = () => {
      const items = getSetItemsForCurrentVariant();
      const issue = getSetAvailabilityIssue(items);
      root.hidden = cfg.hasDigital && !items.length;
      setSubmitButtonState(issue);
      setAvailabilityInfoState(issue);
      setBackInStockFormState(issue);
    };

    const dispatchUpdate = () => {
      const recipeV = getCurrentRecipeVariant();
      const items = getSetItems();
      const mainQty = getMainQuantity();

      document.dispatchEvent(new CustomEvent('prp:selection-change', {
        bubbles: true,
        detail: {
          recipeVariant: recipeV ? {
            id: recipeV.id,
            product_title: cfg.productTitle,
            product_url: cfg.productUrl,
            option_title: recipeV.option1,
            price: recipeV.price,
            quantity: 1
          } : null,
          setItems: items.map((item, i) => {
            const sel = getDisplaySelection(i, item);
            const selV =
              item.variants.find(v => v.id === sel.variantId) ||
              item.variants.find(v => v.id === item.default_variant_id) ||
              item.variants[0];

            return {
              product_title: item.product_title,
              product_url: item.product_url,
              selected_title: selV ? selV.title : null,
              quantity: Number(sel.quantity || 0) * mainQty,
              base_quantity: Number(sel.quantity || 0),
              multiplier_quantity: mainQty,
              price: selV ? selV.price : 0
            };
          })
        }
      }));
    };

    const afterSelectionChange = () => {
      syncFormVariant();
      render();
      refreshUpsellForVariant(getCurrentRecipeVariant()?.id);
      dispatchUpdate();
      schedulePriceDisplayUpdate();
      updateSetAvailabilityDisplay();
    };

    const handleMainQtyChanged = () => {
      render();
      dispatchUpdate();
      schedulePriceDisplayUpdate();
      updateSetAvailabilityDisplay();
    };

    // Returns discount % for a given option value, 0 if no discount
    const getDiscountPct = (optionIndex, val) => {
      const testOpts = [...selectedOptions];
      testOpts[optionIndex] = val;
      const v = findVariant(testOpts) ||
        variants.find(vv => [vv.option1, vv.option2, vv.option3][optionIndex] === val);
      if (!v || !v.compare_at_price || v.compare_at_price <= v.price) return 0;
      return Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100);
    };

    const renderOptionStep = (el, step, idx, isActive, isPast, steps) => {
      const { optionIndex, optionName } = step;
      const selectedVal = selectedOptions[optionIndex];
      const isFirst = optionIndex === 0;

      const rawVals = [...new Set(
        variants.map(v => [v.option1, v.option2, v.option3][optionIndex]).filter(v => v != null)
      )];
      const hasNonDigitalValues = rawVals.some(val => val !== 'Digital');
      const allVals = rawVals.filter(val => {
        // Hide unusable Digital only on mixed format products. If Digital is the only
        // format, keep the step visible and let the native product submit flow work.
        if (val !== 'Digital') return true;
        if (!hasNonDigitalValues) return true;
        return variants.some(vv =>
          [vv.option1, vv.option2, vv.option3][optionIndex] === 'Digital' &&
          (sets[String(vv.id)] || []).length > 0
        );
      });

      const getVariantForOptionValue = (val) => {
        const testOpts = [...selectedOptions];
        testOpts[optionIndex] = val;

        return findVariant(testOpts) ||
          variants.find(v => {
            const o = [v.option1, v.option2, v.option3];
            return o[optionIndex] === val &&
              selectedOptions.every((sel, i) => i === optionIndex || sel == null || o[i] === sel);
          }) ||
          variants.find(v => [v.option1, v.option2, v.option3][optionIndex] === val) ||
          null;
      };

      const getOptionValueIssue = (val) => {
        const candidate = getVariantForOptionValue(val);
        return getConfiguredSetAvailabilityIssueForVariant(candidate);
      };

      const isValAvail = (val) =>
        variants.some(v => {
          const o = [v.option1, v.option2, v.option3];
          return o[optionIndex] === val &&
            v.available &&
            v.variation_set_missing !== true &&
            selectedOptions.every((sel, i) => i === optionIndex || sel == null || o[i] === sel);
        });

      const getOptionSwatchImage = (val) => {
        const matchesSelectedContext = variants.find(v => {
          const o = [v.option1, v.option2, v.option3];
          return o[optionIndex] === val &&
            v.swatch_image &&
            selectedOptions.every((sel, i) => i === optionIndex || sel == null || o[i] === sel);
        });

        if (matchesSelectedContext?.swatch_image) return matchesSelectedContext.swatch_image;

        const anyMatchingVariant = variants.find(v => {
          const o = [v.option1, v.option2, v.option3];
          return o[optionIndex] === val && v.swatch_image;
        });

        return anyMatchingVariant?.swatch_image || '';
      };

      const cleanName = String(optionName || '').trim();
      const lowerName = cleanName.toLowerCase();
      const fieldTitle = isFirst
        ? str('choosePatternFormat', 'Choose your pattern format')
        : (lowerName.includes('size') || lowerName.includes('größe') || lowerName.includes('groesse')
          ? str('chooseSize', 'Choose your size')
          : formatStr('chooseOption', { option: cleanName }, `Choose ${cleanName}`));

      // Swatch images are stored on the product variant via the Option values metaobject.
      // Use them only for real color options. Other options such as Digital must stay text buttons.
      // Also do not replace values without images by gray dots — keep them as normal text pills.
      const optionAllowsSwatches = !isFirst && isColorOption(optionName);
      const hasAnySwatchImage = optionAllowsSwatches && allVals.some(val => getOptionSwatchImage(val));

      el.classList.add('is-active');
      el.innerHTML = `
        <div class="prp__config-field">
          <div class="prp__config-field-title">${esc(fieldTitle)}</div>
          <div class="${isFirst ? 'prp__format-group' : (hasAnySwatchImage ? 'prp__mixed-options' : 'prp__pills')}">
            ${allVals.map(val => {
              const avail = isValAvail(val);
              const active = val === selectedVal;
              const displayVal = isFirst
                ? (String(val).trim().toLowerCase() === 'digital'
                  ? str('digitalFormat')
                  : str('printedFormat'))
                : val;
              const discPct = !isFirst ? getDiscountPct(optionIndex, val) : 0;
              const swatchImage = hasAnySwatchImage ? getOptionSwatchImage(val) : '';
              const optionValueIssue = isFirst ? null : getOptionValueIssue(val);
              const showOosMarker = !avail || !!optionValueIssue;

              if (swatchImage) {
                return `
                  <button
                    type="button"
                    class="prp__swatch${active ? ' is-active' : ''}${showOosMarker ? ' is-oos' : ''}"
                    data-opt-val="${esc(val)}"
                    data-opt-idx="${optionIndex}"
                    title="${esc(val)}"
                    aria-label="${esc(val)}"
                    ${!avail ? 'disabled' : ''}
                  >
                    <span class="prp__swatch-img" style="background-image:url('${esc(swatchImage)}')"></span>
                    <span class="prp__swatch-x">×</span>
                  </button>
                `;
              }

              const cls = isFirst ? 'prp__format-btn' : 'prp__pill';
              return `
                <button
                  type="button"
                  class="${cls}${active ? ' is-active' : ''}${showOosMarker ? ' is-oos' : ''}"
                  data-opt-val="${esc(val)}"
                  data-opt-idx="${optionIndex}"
                  ${!avail ? 'disabled' : ''}
                >
                  <span class="prp__option-label">${esc(displayVal)}</span>
                  ${discPct > 0 ? `<span class="prp__pill-badge">%</span>` : ''}
                  ${showOosMarker ? '<span class="prp__option-x">×</span>' : ''}
                </button>
              `;
            }).join('')}
          </div>
        </div>`;

      el.querySelectorAll('[data-opt-val]').forEach(btn => {
        btn.addEventListener('click', () => {
          const optIdx = parseInt(btn.dataset.optIdx, 10);
          const newVal = btn.dataset.optVal;
          const changed = selectedOptions[optIdx] !== newVal;
          const previousItems = changed && !isColorOption(options[optIdx]) ? getSetItems() : [];
          selectedOptions[optIdx] = newVal;
          if (changed) resetSetSteps(previousItems);
          updatePriceDisplay();
          afterSelectionChange();
        });
      });
    };

    const renderSetStep = (el, step, idx, isActive, isPast, steps) => {
      const { setIndex, item } = step;
      const liveSel = getDisplaySelection(setIndex, item);

      const selV =
        item.variants.find(v => v.id === liveSel?.variantId) ||
        item.variants.find(v => v.id === item.default_variant_id) ||
        item.variants[0];

      const qty = Number((liveSel && liveSel.quantity) || 0);
      const previewImage = selV && selV.image ? selV.image : '';
      const selectedText = selV ? selV.title : str('notSelected', 'Not selected yet');
      const setTitle = item.product_title || formatStr('accentYarn', { number: String(setIndex + 1) }, `Yarn ${setIndex + 1} for accents`);
      const colorStepLabel = `${str('color', 'Color')} ${setIndex + 1}: ${selectedText}`;

      el.classList.add('prp__set-block');
      if (isActive) el.classList.add('is-active');

      el.innerHTML = `
        <div class="prp__color-label">${esc(colorStepLabel)}</div>

        ${isActive ? `
          <div class="prp__color-editor">
            <div class="prp__swatches" data-swatches>
              ${(() => {
                const sorted = [...item.variants];
                const selIdx = sorted.findIndex(v => v.id === liveSel.variantId);
                if (selIdx > 0) { const [sel] = sorted.splice(selIdx, 1); sorted.unshift(sel); }
                return sorted.map((v, vi) => `
                  <button
                    type="button"
                    class="prp__swatch${v.id === liveSel.variantId ? ' is-active' : ''}${!v.available ? ' is-oos' : ''}"
                    data-set-idx="${setIndex}"
                    data-vid="${v.id}"
                    title="${esc(v.title)}"
                    aria-label="${esc(v.title)}"
                    ${vi >= SWATCH_LIMIT ? 'data-extra' : ''}
                    ${!v.available ? 'disabled' : ''}
                  >
                    ${v.image
                      ? `<span class="prp__swatch-img" style="background-image:url('${esc(v.image)}')"></span>`
                      : `<span class="prp__swatch-dot"></span>`}
                    <span class="prp__swatch-x">×</span>
                  </button>
                `).join('');
              })()}
            </div>

            <div class="prp__color-actions">
              <button type="button" class="prp__color-nav-btn prp__color-nav-btn--prev" data-prp-color-prev>${esc(str('previous', 'Previous'))}</button>
              <button type="button" class="prp__color-nav-btn prp__color-nav-btn--next" data-prp-color-next>${esc(str('next', 'Next'))}</button>
            </div>
          </div>
        ` : `
          <div class="prp__set-row">
            <span class="prp__set-preview" ${previewImage ? `style="background-image:url('${esc(previewImage)}')"` : ''}></span>
            <span class="prp__set-text">
              <span class="prp__set-name">${esc(setTitle)}:</span>
              <span class="prp__set-selected"> ${esc(selectedText)} × ${qty}</span>
            </span>
            <button type="button" class="prp__edit-btn" data-prp-edit-set="${setIndex}">${esc(str('change', 'Change'))}</button>
          </div>
        `}`;

      el.querySelector('[data-prp-edit-set]')?.addEventListener('click', () => {
        activeSetIndex = setIndex;
        render();
      });

      el.querySelector('[data-prp-color-prev]')?.addEventListener('click', () => {
        activeSetIndex = Math.max(0, setIndex - 1);
        render();
      });

      el.querySelector('[data-prp-color-next]')?.addEventListener('click', () => {
        const setSteps = buildSteps().filter(s => s.type === 'set');
        activeSetIndex = setIndex >= setSteps.length - 1 ? null : setIndex + 1;
        render();
      });

      el.querySelectorAll('[data-vid]').forEach(btn => {
        btn.addEventListener('click', () => {
          const si = parseInt(btn.dataset.setIdx, 10);
          setSelections[si] = setSelections[si] || {};
          setSelections[si].variantId = parseInt(btn.dataset.vid, 10);
          setSelections[si].customized = true;
          if (typeof setSelections[si].quantity !== 'number') {
            setSelections[si].quantity = Number(parseInt(item.quantity, 10) || 0);
          }
          afterSelectionChange();
        });
      });
    };

    const render = () => {
      const steps = buildSteps();
      ensureSelectionsForItems(getSetItems());
      mount.innerHTML = '';

      const optionSteps = steps.filter(step => step.type === 'option');
      const setSteps = steps.filter(step => step.type === 'set');

      const card = document.createElement('div');
      card.className = 'prp__config-card';
      card.innerHTML = `<p class="prp__config-title">${esc(str('configureSet', 'Configure your knitting set'))}</p>`;

      // A product with a single variant has nothing to choose, so its option rows are not shown.
      const orderedOptionSteps = variants.length > 1 ? [
        ...optionSteps.filter(step => step.optionIndex === 0),
        ...optionSteps.filter(step => step.optionIndex !== 0)
      ] : [];
      const showCustomize = setSteps.length && !cfg.hideConfigurator;
      if (!orderedOptionSteps.length) {
        card.querySelector('.prp__config-title')?.remove();
        card.classList.add('prp__config-card--no-options');
      }

      orderedOptionSteps.forEach((step) => {
        const el = document.createElement('div');
        el.className = 'prp__step';
        const realIndex = steps.indexOf(step);
        renderOptionStep(el, step, realIndex, true, false, steps);
        card.appendChild(el);
      });

      if (showCustomize) {
        const custom = document.createElement('div');
        custom.className = 'prp__customize';
        custom.innerHTML = `
          <div class="prp__customize-label">${esc(str('notYourColor', 'Not your color?'))}</div>
          <button type="button" class="prp__customize-btn" data-prp-toggle-config>
            ${esc(configuratorOpen ? str('hideColorSelection', 'Hide color selection') : str('buildSet', 'Build your own set'))}
          </button>
        `;
        custom.querySelector('[data-prp-toggle-config]')?.addEventListener('click', () => {
          configuratorOpen = !configuratorOpen;
          activeSetIndex = configuratorOpen ? 0 : null;
          render();
        });
        card.appendChild(custom);
      }

      if (orderedOptionSteps.length || showCustomize) mount.appendChild(card);

      if (!configuratorOpen) return;

      setSteps.forEach((step) => {
        const el = document.createElement('div');
        el.className = 'prp__step';
        const realIndex = steps.indexOf(step);
        const isPast = activeSetIndex !== step.setIndex;
        const isActive = activeSetIndex === step.setIndex;
        renderSetStep(el, step, realIndex, isActive, isPast, steps);
        mount.appendChild(el);
      });
    };

    const getSectionsUrl = (sectionIds) => {
      const rootUrl = window.Shopify?.routes?.root || '/';
      return `${rootUrl}?sections=${sectionIds.join(',')}`;
    };

    const parseHTML = (html) => new DOMParser().parseFromString(html, 'text/html');

    const closeDrawerIfEmpty = async () => {
      try {
        const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json());
        if (cart.item_count > 0) return;

        const drawerHost = document.querySelector('cart-drawer');
        const closeBtn =
          drawerHost?.querySelector('.drawer__close') ||
          drawerHost?.querySelector('[aria-label*="close" i]') ||
          drawerHost?.querySelector('[aria-label*="schließen" i]') ||
          drawerHost?.querySelector('[data-drawer-close]');

        if (closeBtn) {
          closeBtn.click();
          return;
        }

        if (drawerHost) {
          drawerHost.classList.remove('active', 'animate');
          drawerHost.classList.add('is-empty');
        }

        document.body.classList.remove('overflow-hidden');
      } catch (err) {}
    };

    const hardRefreshCartCount = async () => {
      try {
        const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        if (!res.ok) return null;
        const cart = await res.json();

        document.querySelectorAll('[data-cart-count], .cart-count-bubble span').forEach((el) => {
          el.textContent = cart.item_count;
        });

        return cart;
      } catch (err) {
        return null;
      }
    };

    const openDrawer = () => {
      const drawerHost = document.querySelector('cart-drawer');
      if (!drawerHost) return;

      drawerHost.classList.add('active', 'animate');
      drawerHost.removeAttribute('aria-hidden');
      document.body.classList.add('overflow-hidden');

      const overlay =
        drawerHost.querySelector('.drawer__overlay') ||
        drawerHost.querySelector('[id^="CartDrawer-Overlay"]') ||
        document.querySelector('.drawer__overlay');

      if (overlay) {
        overlay.addEventListener('click', () => {
          closeDrawer(drawerHost);
        }, { once: true });
      }
    };

    const closeDrawer = (drawerHost) => {
      const host = drawerHost || document.querySelector('cart-drawer');
      if (!host) return;
      host.classList.remove('active', 'animate');
      host.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('overflow-hidden');
    };

    const bindDrawerCloseBehavior = () => {
      const drawerHost = document.querySelector('cart-drawer');
      if (!drawerHost || drawerHost.dataset.prpDrawerBound) return;

      drawerHost.dataset.prpDrawerBound = 'true';

      drawerHost.addEventListener('click', (e) => {
        const overlayClicked =
          e.target.classList?.contains('drawer__overlay') ||
          e.target.matches('[id^="CartDrawer-Overlay"]');

        const closeClicked = e.target.closest(
          '.drawer__close, [data-drawer-close], [aria-label*="close" i], [aria-label*="schließen" i]'
        );

        if (overlayClicked || closeClicked) {
          e.preventDefault();
          closeDrawer(drawerHost);
        }
      });
    };

    const refreshCartDrawer = async () => {
      const sectionIds = ['cart-drawer', 'cart-icon-bubble'];
      const url = getSectionsUrl(sectionIds);
      const cart = await hardRefreshCartCount();

      const res = await fetch(url, {
        method: 'GET',
        headers: { Accept: 'application/json' }
      });

      if (!res.ok) throw new Error('sections request failed');

      const payload = await res.json();

      if (payload['cart-icon-bubble']) {
        // The section response IS the inner content of #cart-icon-bubble (an <a> tag in the header).
        // Set innerHTML directly — the #cart-icon-bubble wrapper does not appear inside the section output.
        const curBubble = document.querySelector('#cart-icon-bubble');
        if (curBubble) curBubble.innerHTML = payload['cart-icon-bubble'];
      }

      if (payload['cart-drawer']) {
        const drawerDoc = parseHTML(payload['cart-drawer']);
        const nextHost =
          drawerDoc.querySelector('cart-drawer') ||
          drawerDoc.querySelector('#shopify-section-cart-drawer cart-drawer');

        const curHost = document.querySelector('cart-drawer');

        if (curHost && nextHost) {
          curHost.className = nextHost.className;
          curHost.innerHTML = nextHost.innerHTML;
        } else {
          const nextDrawerInner =
            drawerDoc.querySelector('#CartDrawer') ||
            drawerDoc.querySelector('.drawer');

          const curDrawerInner =
            document.querySelector('cart-drawer #CartDrawer') ||
            document.querySelector('#CartDrawer') ||
            document.querySelector('cart-drawer .drawer');

          if (curDrawerInner && nextDrawerInner) {
            curDrawerInner.innerHTML = nextDrawerInner.innerHTML;
          }
        }
      }

      const drawerHost = document.querySelector('cart-drawer');
      if (drawerHost && cart && cart.item_count > 0) {
        drawerHost.classList.remove('is-empty');
      }

      bindDrawerCloseBehavior();

      if (cart && cart.item_count === 0) {
        await closeDrawerIfEmpty();
        return;
      }

      openDrawer();
    };

    const getSetItemsForCurrentVariant = () => {
      if (cfg.hasDigital) {
        return getSetItems();
      }
      const form = getProductForm();
      const formInput = form && form.querySelector('input[name="id"]');
      const formVariantId = formInput ? parseInt(formInput.value, 10) : null;
      const raw = formVariantId ? (sets[String(formVariantId)] || []) : [];
      const src = raw.length ? raw : (initV ? (sets[String(initV.id)] || []) : []);
      return [...src].sort((a, b) => (parseInt(a.position, 10) || 0) - (parseInt(b.position, 10) || 0));
    };

    document.addEventListener('submit', async (e) => {
      const productForm = getProductForm();
      if (!productForm || e.target !== productForm) return;

      const currentSetItems = getSetItemsForCurrentVariant();
      console.log('[PRP] submit fired — currentSetItems:', JSON.stringify(currentSetItems));
      if (!currentSetItems.length) {
        if (cfg.hasDigital) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          updateSetAvailabilityDisplay();
          return;
        }
        console.log('[PRP] no set items, letting native submit proceed');
        return;
      }

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      const availabilityIssue = getSetAvailabilityIssue(currentSetItems);
      if (availabilityIssue) {
        updateSetAvailabilityDisplay();
        return;
      }

      const submitBtn = productForm.querySelector('[type="submit"]');
      const origHTML = submitBtn?.innerHTML || '';

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.innerHTML = str('adding', 'Adding…');
      }

      try {
        const mainQty = getMainQuantity();

        ensureSelectionsForItems(currentSetItems);

        let bundlePrice = 0;
        const recipeVariant = cfg.hasDigital ? getCurrentRecipeVariant() : null;
        const isRecipeDigital = recipeVariant && (
          recipeVariant.option1 === 'Digital' ||
          recipeVariant.option2 === 'Digital' ||
          recipeVariant.option3 === 'Digital'
        );

        if (isRecipeDigital) {
          // Digital format selected: _bundle_price = digital.price + sum(yarn prices per bundle).
          // Discount function sees actual == target → 0 discount (yarn is at full retail price).
          bundlePrice += Number(recipeVariant.price || 0);
          currentSetItems.forEach((item, i) => {
            if (isDigitalInstructionItem(item)) return;

            const live = getDisplaySelection(i, item);
            if (!live?.variantId) return;
            const qty = Number(live.quantity || 0);
            if (qty <= 0) return;
            const yarnV = item.variants.find(v => v.id === live.variantId)
              || item.variants.find(v => v.id === item.default_variant_id)
              || item.variants[0];
            if (yarnV?.price) bundlePrice += Number(yarnV.price) * qty;
          });
        } else {
          // Physical format (or pure non-digital product):
          // _bundle_price = the bundle variant price; discount function discounts yarn to match.
          const _form = getProductForm();
          const _input = _form && _form.querySelector('input[name="id"]');
          const _vid = _input ? parseInt(_input.value, 10) : null;
          const _fv = _vid ? variants.find(v => v.id === _vid) : null;
          bundlePrice = _fv ? Number(_fv.price || 0) : (initV ? Number(initV.price || 0) : 0);
        }

        const cartItems = [];
        const bundleKey = 'bndl_' + Date.now() + '_' + Math.random().toString(36).slice(2, 7);
        const bundleProperties = {
          '_bundle_key': bundleKey,
          '_bundle_title': cfg.productTitle || '',
          '_bundle_url': cfg.productUrl || '',
          '_bundle_image': cfg.productImage || '',
          '_bundle_price': String(bundlePrice * mainQty)
        };

        // Add the digital recipe variant as the first bundle item only when Digital format is selected.
        if (isRecipeDigital) {
          cartItems.push({
            id: recipeVariant.id,
            quantity: mainQty,
            properties: bundleProperties
          });
        } else {
          currentSetItems.forEach((item, i) => {
            if (!isDigitalInstructionItem(item)) return;

            const live = getDisplaySelection(i, item);
            const qty = Number(live?.quantity || item.quantity || 1);
            const digitalVariantId = live?.variantId || item.default_variant_id;
            if (!digitalVariantId || qty <= 0) return;

            cartItems.push({
              id: digitalVariantId,
              quantity: qty * mainQty,
              properties: {
                ...bundleProperties,
                '_bundle_component': 'digital_instruction'
              }
            });
          });
        }

        currentSetItems.forEach((item, i) => {
          if (isDigitalInstructionItem(item)) return;

          const live = getDisplaySelection(i, item);
          if (!live?.variantId) return;
          const qty = Number(live.quantity || 0);
          if (qty <= 0) return;
          const selV = item.variants.find(v => v.id === live.variantId);
          cartItems.push({
            id: live.variantId,
            quantity: qty * mainQty,
            properties: bundleProperties
          });
        });

        console.log('[PRP] cartItems to send:', JSON.stringify(cartItems));
        if (!cartItems.length) throw new Error(str('addFailed', 'No valid cart items found for this bundle'));

        const addRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: cartItems })
        });

        const addData = await addRes.json();
        console.log('[PRP] cart/add.js response:', addRes.status, JSON.stringify(addData));
        if (!addRes.ok) throw new Error(addData?.description || str('addFailed', 'cart/add.js failed'));

        // Apply bundle discount code (non-fatal — cart add already succeeded)
        if (!isRecipeDigital) {
          try {
            // Actual yarn total in cents
            let actualYarnCents = 0;
            currentSetItems.forEach((item, i) => {
              if (isDigitalInstructionItem(item)) return;

              const live = getDisplaySelection(i, item);
              if (!live?.variantId) return;
              const qty = Number(live.quantity || 0);
              if (qty <= 0) return;
              const selV = item.variants.find(v => v.id === live.variantId);
              if (selV?.price) actualYarnCents += Number(selV.price) * qty * mainQty;
            });
            const discountCents = actualYarnCents - bundlePrice * mainQty;

            if (discountCents > 0) {
              const dcRes = await fetch('https://gruendl-bundle-discount.fly.dev/api/create-discount', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ discountCents })
              });
              const { code } = await dcRes.json();
              if (code) {
                // Apply the discount code to the Shopify cart session
                await fetch(`/discount/${encodeURIComponent(code)}`, {
                  credentials: 'include',
                  redirect: 'manual'
                });
                console.log('[PRP] discount code applied:', code, '(-' + (discountCents / 100).toFixed(2) + '€)');
              }
            }
          } catch (dcErr) {
            console.warn('[PRP] discount code creation failed (non-fatal):', dcErr);
          }
        }

        await refreshCartDrawer();

        if (submitBtn) {
          submitBtn.innerHTML = str('added', '✓ Added');
          setTimeout(() => {
            submitBtn.innerHTML = origHTML;
            submitBtn.disabled = false;
            updateSetAvailabilityDisplay();
          }, 2000);
        }
      } catch (err) {
        console.error('[PRP] submit error:', err);
        if (submitBtn) {
          submitBtn.disabled = false;
          // Show the error message in the button for a few seconds so it's visible.
          submitBtn.innerHTML = '⚠ ' + esc(err.message || str('error', 'Error'));
          setTimeout(() => {
            submitBtn.innerHTML = origHTML;
            updateSetAvailabilityDisplay();
          }, 5000);
        }
      }
    }, true);

    const bindDrawerEmptyWatcher = () => {
      document.addEventListener('click', (e) => {
        const removeBtn = e.target.closest(
          'cart-drawer [href*="/cart/change"], cart-drawer [data-index], cart-drawer .quantity__button, cart-drawer cart-remove-button button, cart-drawer [name="minus"], cart-drawer [name="plus"]'
        );
        if (!removeBtn) return;
        setTimeout(() => {
          closeDrawerIfEmpty();
        }, 700);
      });
    };

	    const bindMainQtyWatcher = () => {
	      const productRoot = document.getElementById('MainProduct-' + cfg.sectionId) || document;
	      const form = getProductForm();

      const onQtyChangeSoon = () => {
        setTimeout(() => handleMainQtyChanged(), 0);
        setTimeout(() => handleMainQtyChanged(), 60);
        setTimeout(() => handleMainQtyChanged(), 180);
      };

      form?.addEventListener('input', (e) => {
        if (e.target && (e.target.matches('input[name="quantity"]') || e.target.matches('.quantity__input') || e.target.closest('quantity-input'))) {
          onQtyChangeSoon();
        }
      });

      form?.addEventListener('change', (e) => {
        if (e.target && (e.target.matches('input[name="quantity"]') || e.target.matches('.quantity__input') || e.target.closest('quantity-input'))) {
          onQtyChangeSoon();
        }
      });

      productRoot.addEventListener('click', (e) => {
        const btn = e.target.closest('.quantity__button, quantity-input button, [name="plus"], [name="minus"]');
        if (!btn) return;
        onQtyChangeSoon();
	      });
	    };

    const bindVariantChangeWatcher = () => {
      if (!cfg.hasDigital && cfg.productUrl?.endsWith('-10er-pack')) {
        document.addEventListener('pvsel:variant-select', (event) => {
          const variant = variants.find(v => String(v.id) === String(event.detail?.variantId));
          if (!variant) return;

          selectedOptions.forEach((_, index) => {
            selectedOptions[index] = variant[`option${index + 1}`] ?? null;
          });
          Object.keys(setSelections).forEach(key => delete setSelections[key]);
          ensureSelectionsForItems(getSetItemsForVariant(variant));
          schedulePriceDisplayUpdate();
          setTimeout(updateSetAvailabilityDisplay, 0);
        });
      }

      if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.variantChange) {
        return;
      }

      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const sectionId = event?.data?.sectionId;
        if (sectionId && sectionId !== cfg.sectionId) return;
        schedulePriceDisplayUpdate();
        setTimeout(updateSetAvailabilityDisplay, 0);
        setTimeout(updateSetAvailabilityDisplay, 150);
      });
    };

    const bindBackInStockBridge = () => {
      if (document.documentElement.dataset.prpBisBridgeBound === 'true') return;
      document.documentElement.dataset.prpBisBridgeBound = 'true';

      const handleBackInStockSubmit = (event, explicitSubmit) => {
        const target = event.target;
        if (!target || typeof target.closest !== 'function') return;

        const submit = explicitSubmit || target.closest('#appikon-bis-inline-form-submit');
        const form = submit?.closest('#appikon-bis-inline-form-wrapper') ||
          target.closest('#appikon-bis-inline-form-wrapper');
        if (!form || form.dataset.prpBisActive !== 'true') return;

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        const variantId = parseInt(form.dataset.prpBisVariantId, 10);
        const productId = parseInt(form.dataset.prpBisProductId, 10);
        const email = form.querySelector('#appikon-bis-inline-form-email')?.value?.trim() || null;
        const phone = form.querySelector('#appikon-bis-inline-form-phone-no')?.value?.trim() || null;
        const acceptsMarketing = !!form.querySelector('#customer_accepts_marketing')?.checked;
        const message = form.querySelector('#appikon-bis-inline-form-message');

        if (!variantId || !productId || !window.SI || typeof window.SI.submitNotificationData !== 'function') {
          if (message) {
            message.innerHTML = '<p class="appikon-bis-inline-form-error">' + esc(str('bisRetry', 'Please try again.')) + '</p>';
          }
          return;
        }

        if (!email && !phone) {
          if (message) {
            message.innerHTML = '<p class="appikon-bis-inline-form-error">' + esc(str('bisContactRequired', 'Please enter your email address or phone number.')) + '</p>';
          }
          return;
        }

        if (submit) submit.disabled = true;
        if (message) {
          message.innerHTML = '<p class="appikon-bis-inline-form-info">' + esc(str('bisSaving', 'Saving...')) + '</p>';
        }

        const popup = window.SI.popup || {};
        const ajaxUrl = popup.ajaxOpts?.url;
        const shop = popup.settings?.shop || window.Shopify?.shop;
        const notification = {
          product_no: productId,
          quantity_required: 1,
          accepts_marketing: acceptsMarketing,
          customer_utc_offset: 60 * new Date().getTimezoneOffset()
        };
        const variantPayload = {
          variant_no: variantId
        };

        if (form.dataset.prpBisProductTitle) notification.product_title = form.dataset.prpBisProductTitle;
        if (form.dataset.prpBisProductVendor) notification.product_vendor = form.dataset.prpBisProductVendor;
        if (form.dataset.prpBisProductHandle) notification.product_handle = form.dataset.prpBisProductHandle;
        if (form.dataset.prpBisVariantTitle) variantPayload.variant_title = form.dataset.prpBisVariantTitle;
        if (form.dataset.prpBisVariantSku) variantPayload.sku = form.dataset.prpBisVariantSku;
        if (email) notification.email = email;
        if (phone) notification.phone_number = phone;

        const request = {
          shop,
          notification,
          variant: variantPayload
        };

        if (!ajaxUrl || !shop) {
          if (message) {
            message.innerHTML = '<p class="appikon-bis-inline-form-error">' + esc(str('bisRetry', 'Please try again.')) + '</p>';
          }
          if (submit) submit.disabled = false;
          return;
        }

        let requestCompleted = false;
        const requestTimeout = window.setTimeout(() => {
          if (requestCompleted) return;
          requestCompleted = true;
          if (message) {
            message.innerHTML = '<p class="appikon-bis-inline-form-error">' + esc(str('bisRetry', 'Please try again.')) + '</p>';
          }
          if (submit) submit.disabled = false;
        }, 12000);

        try {
          window.SI.submitNotificationData(ajaxUrl, request).then((status, response) => {
            if (requestCompleted) return;
            requestCompleted = true;
            window.clearTimeout(requestTimeout);

            let parsed = {};

            try {
              parsed = typeof response === 'object'
                ? response
                : (typeof window.SI.parseJSON === 'function'
                  ? window.SI.parseJSON(response)
                  : JSON.parse(response || '{}'));
            } catch (error) {
              parsed = {};
            }

            const ok = !status && parsed && parsed.status === 'OK';

            if (message) {
              message.innerHTML = ok
                ? '<p class="appikon-bis-inline-form-success">' + esc(str('bisSuccess', 'Your notification has been registered.')) + '</p>'
                : '<p class="appikon-bis-inline-form-error">' + esc(str('bisRetry', 'Please try again.')) + '</p>';
            }

            if (submit) submit.disabled = false;
          });
        } catch (error) {
          requestCompleted = true;
          window.clearTimeout(requestTimeout);
          if (message) {
            message.innerHTML = '<p class="appikon-bis-inline-form-error">' + esc(str('bisRetry', 'Please try again.')) + '</p>';
          }
          if (submit) submit.disabled = false;
        }
      };

      document.addEventListener('click', (event) => {
        const target = event.target;
        if (!target || typeof target.closest !== 'function') return;
        const submit = target.closest('#appikon-bis-inline-form-submit');
        if (!submit) return;
        handleBackInStockSubmit(event, submit);
      }, true);

      document.addEventListener('submit', (event) => {
        const form = event.target?.closest?.('#appikon-bis-inline-form');
        if (!form) return;
        const submit = form.querySelector('#appikon-bis-inline-form-submit');
        handleBackInStockSubmit(event, submit);
      }, true);
    };

    const initDOM = () => {
	      if (cfg.hasDigital) {
        const mainProductEl = document.getElementById('MainProduct-' + cfg.sectionId) || document;
        mainProductEl.querySelectorAll('[data-pvsel], variant-selects, variant-radios').forEach((el) => {
          el.hidden = true;
        });

        ensureSelectionsForItems(getSetItems());
        render();
        // Defer dispatchUpdate so sibling snippets (e.g. pdp-variation-set) have time
        // to register their prp:selection-change listeners before the event fires.
	        setTimeout(() => dispatchUpdate(), 0);
	        syncFormVariant();
	        setTimeout(() => refreshUpsellForVariant(getCurrentRecipeVariant()?.id), 0);
	        setTimeout(updateSetAvailabilityDisplay, 0);
	        setTimeout(updateSetAvailabilityDisplay, 150);
	      }

      // Also initialise the visual price for physical bundles. Their component
      // data can arrive before the ERP assigns the bundle variant price.
      schedulePriceDisplayUpdate();
	      bindDrawerEmptyWatcher();
	      bindMainQtyWatcher();
	      bindVariantChangeWatcher();
	      bindDrawerCloseBehavior();
	      bindBackInStockBridge();
	      setTimeout(updateSetAvailabilityDisplay, 0);
	      setTimeout(updateSetAvailabilityDisplay, 150);
	    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initDOM);
    } else {
      initDOM();
    }
  }

  function initAll(scope) {
    var context = scope || document;

    if (context.matches && context.matches('[data-prp-root]')) {
      init(context);
    }

    context.querySelectorAll('[data-prp-root]').forEach(init);
  }

  function boot() {
    initAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
